import { Flex } from '../../../../common/Flex';
import { Button, Checkbox, Select } from 'antd';
import React, { PureComponent } from 'react';
import { SettingsContentPanel } from '../../../../common/SettingsContentPanel';

export const DEFAULT_WHOLE_NETWORK_SETTINGS: WholeNetworkSettings = {
    sortBy: 'geography',
    tv: 'all',
    load: 'all',
    showOccupancy: true,
    occupancy: 'all',
    showOccupancyForTv: true,
    occupancyForTv: 'all',
    showNonMonitorableTv: true,
    showLoadInactivePeriods: false,
};

export interface WholeNetworkSettings {
    sortBy: 'name' | 'geography';
    tv: 'all' | 'supervised' | 'regulated' | 'supervised + regulated';
    load: 'all' | 'low' | 'high' | 'overload';
    showOccupancy: boolean;
    occupancy: 'all' | 'sustain' | 'peak';
    showOccupancyForTv: boolean;
    occupancyForTv: 'all' | 'low' | 'high' | 'overload';
    showNonMonitorableTv: boolean;
    showLoadInactivePeriods: boolean;
}

export class WholeNetworkSettingsTitle extends PureComponent {
    render() {
        return (
            <Flex direction="vertical">
                <div style={{ fontWeight: 'bold' }}>SECTION SETTINGS</div>
                <div style={{ fontSize: '0.8em' }}>WHOLE NETWORK</div>
            </Flex>
        );
    }
}

export class WholeNetworkSettingsContent extends SettingsContentPanel<WholeNetworkSettings> {
    render() {
        return (
            <Flex direction="vertical" className="settings-content" style={{ width: '26em', padding: '1em' }}>
                <Flex>
                    <Flex className="label">Sort by</Flex>
                    <Flex size="12em">
                        <Select
                            value={this.state.sortBy}
                            disabled={true}
                            onChange={value => this.setState({ sortBy: value })}
                            style={{ width: '12em' }}
                            // Force render  of dropdown inside the popover content
                            // Fix popover hiding on click
                            getPopupContainer={trigger => trigger.parentNode}>
                            <Select.Option value="name">Name</Select.Option>
                            <Select.Option value="geography">Geography</Select.Option>
                        </Select>
                    </Flex>
                </Flex>
                <Flex>
                    <Flex className="label">Show TFV</Flex>
                    <Flex size="12em">
                        <Select
                            value={this.state.tv}
                            onChange={value => this.setState({ tv: value })}
                            style={{ width: '12em' }}
                            getPopupContainer={trigger => trigger.parentNode}>
                            <Select.Option value="all">All</Select.Option>
                            <Select.Option value="supervised">Supervised</Select.Option>
                            <Select.Option value="regulated">Regulated</Select.Option>
                            <Select.Option value="supervised + regulated">Supervised and regulated</Select.Option>
                        </Select>
                    </Flex>
                </Flex>
                <Flex>
                    <Flex className="label">Entry Load</Flex>
                    <Flex size="12em">
                        <Select
                            value={this.state.load}
                            onChange={value => this.setState({ load: value })}
                            style={{ width: '12em' }}
                            getPopupContainer={trigger => trigger.parentNode}>
                            <Select.Option value="all">All</Select.Option>
                            <Select.Option value="low">Low threshold</Select.Option>
                            <Select.Option value="high">High threshold</Select.Option>
                            <Select.Option value="overload">Overload</Select.Option>
                        </Select>
                    </Flex>
                </Flex>
                <Flex>
                    <Flex className="label">
                        <Checkbox
                            checked={this.state.showOccupancy}
                            onChange={value => this.setState({ showOccupancy: value.target.checked })}>
                            Show occupancy
                        </Checkbox>
                    </Flex>
                    <Flex size="12em">
                        <Select
                            value={this.state.occupancy}
                            disabled={!this.state.showOccupancy}
                            onChange={value => this.setState({ occupancy: value })}
                            style={{ width: '12em' }}
                            getPopupContainer={trigger => trigger.parentNode}>
                            <Select.Option value="all">All</Select.Option>
                            <Select.Option value="sustain">Sustain value</Select.Option>
                            <Select.Option value="peak">Peak value</Select.Option>
                        </Select>
                    </Flex>
                </Flex>
                <Flex style={{ paddingLeft: '2em' }}>
                    <Flex className="label">
                        <Checkbox
                            checked={this.state.showOccupancyForTv}
                            disabled={!this.state.showOccupancy}
                            onChange={value => this.setState({ showOccupancyForTv: value.target.checked })}>
                            Occupancy load
                        </Checkbox>
                    </Flex>
                    <Flex size="12em">
                        <Select
                            value={this.state.occupancyForTv}
                            disabled={!this.state.showOccupancy || !this.state.showOccupancyForTv}
                            onChange={value => this.setState({ occupancyForTv: value })}
                            style={{ width: '12em' }}
                            getPopupContainer={trigger => trigger.parentNode}>
                            <Select.Option value="all">All</Select.Option>
                            <Select.Option value="low">Low threshold</Select.Option>
                            <Select.Option value="high">High threshold</Select.Option>
                            <Select.Option value="overload">Overload</Select.Option>
                        </Select>
                    </Flex>
                </Flex>
                <Flex>
                    <Flex className="label">
                        <Checkbox
                            checked={this.state.showNonMonitorableTv}
                            onChange={value => this.setState({ showNonMonitorableTv: value.target.checked })}>
                            Show non-monitorable TVs
                        </Checkbox>
                    </Flex>
                </Flex>
                <Flex>
                    <Flex className="label">
                        <Checkbox
                            checked={this.state.showLoadInactivePeriods}
                            onChange={e => this.setState({ showLoadInactivePeriods: e.target.checked })}>
                            Show load for non-active periods
                        </Checkbox>
                    </Flex>
                </Flex>
                <Flex style={{ justifyContent: 'space-around' }}>
                    <Button onClick={this.handleApply}>Apply</Button>
                    <Button onClick={this.handleClose}>Close</Button>
                </Flex>
            </Flex>
        );
    }
}
